document.addEventListener("DOMContentLoaded", function () {
    const currentURL = window.location.pathname; // get current path
    const navLinks = document.querySelectorAll(".navmenu-link");

    navLinks.forEach(link => {
      const linkHref = link.getAttribute("href");

      if (linkHref === currentURL) {
        const detailsElement = link.closest("details");

        if (detailsElement) {
          detailsElement.setAttribute("open", ""); 
          
          link.classList.add("navmenu-link-active");
        }
      }
    });
  });


// for description-------------------------------------------------------------------


function formatISBNText(text) {
    return text.replace(/(ISBN\s*\d+)(?!\s)/g, '$1 '); 
    // (?!\s) ensures we don't add extra space if already exists
}

// Recursive function to traverse all nodes
function traverseNodes(node) {
    node.childNodes.forEach(child => {
        if (child.nodeType === Node.TEXT_NODE) {
            // Text node: process ISBN
            child.textContent = formatISBNText(child.textContent);
        } else if (child.nodeType === Node.ELEMENT_NODE) {
            // Element node: recurse
            traverseNodes(child);
        }
    });
}

// Start from .product-description
const productDescription = document.querySelector('.product-description');
traverseNodes(productDescription);


const desc = document.querySelector('.product-description');
desc.innerHTML = desc.innerHTML.replace(/ISBN\s+(\d+)\s+(\d+)/, 'ISBN $1$2');





// Function to format ISBN text
// function formatISBNText(text) {
//     return text.replace(/ISBN\s*([\d\s]+)/gi, (match, digits) => {
//         // Remove all spaces from the number part
//         const cleanedDigits = digits.replace(/\s+/g, '');
//         // Add a single space after 'ISBN'
//         return 'ISBN ' + cleanedDigits;
//     });
// }

// // Recursive function to traverse all nodes
// function traverseNodes(node) {
//     node.childNodes.forEach(child => {
//         if (child.nodeType === Node.TEXT_NODE) {
//             // Text node: process ISBN
//             child.textContent = formatISBNText(child.textContent);
//         } else if (child.nodeType === Node.ELEMENT_NODE) {
//             // Element node: recurse
//             traverseNodes(child);
//         }
//     });
// }

// // Start from .product-description
// const productDescription = document.querySelector('.product-description');
// traverseNodes(productDescription);




// function formatISBNText(text) {
//     return text.replace(/ISBN\s*([\d]+)/gi, (match, digits) => {
//         // Add a space after ISBN and keep digits intact
//         return 'ISBN ' + digits;
//     });
// }

// // Recursive function to traverse all nodes
// function traverseNodes(node) {
//     node.childNodes.forEach(child => {
//         if (child.nodeType === Node.TEXT_NODE) {
//             // Text node: process ISBN
//             child.textContent = formatISBNText(child.textContent);
//         } else if (child.nodeType === Node.ELEMENT_NODE) {
//             // Element node: recurse
//             traverseNodes(child);
//         }
//     });
// }

// // Start from .product-description
// const productDescription = document.querySelector('.product-description');
// traverseNodes(productDescription);




